const keyboardDatePickerModalFilterService = {
  from: 'Desde',
  to: 'Hasta'
};

export default keyboardDatePickerModalFilterService;
